import { useMemo } from 'react';

import { heapIdentify } from './useHeap';
import type { User, UserType } from '~/contexts/UserAuthProvider';

// Helpers
const mapUserToDashboardType = (user: User, userType: UserType) => {
  if (userType === 'SUPER_USER') return 'admin';
  if (userType === 'BORROWER') return 'borrower';
  if (userType === 'CAPITAL_PROVIDER') {
    return user.organization.slug === 'valleyBank'
      ? 'securitiesProvider'
      : 'capitalProvider';
  }
  return 'unknown';
};

// Exports
export const useIdentifyHeapUser = () => {
  return useMemo(
    () => ({
      identifyHeapUser: (user: User, userType: UserType) => {
        if (window.heap?.identify) {
          heapIdentify({
            dashboardType: mapUserToDashboardType(user, userType),
            user,
          });
        }
      },
    }),
    [],
  );
};
